// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BACK_TO_HOMEPAGE = "Zp\u011bt na hlavn\u00ed str\u00e1nku";
export const BLOGS_FEED_ALL = "V\u0161echny p\u0159\u00edsp\u011bvky";
export const BLOGS_FEED_FILTER_POST_TYPE = "Zobrazuj";
export const PB_MENU_ALBUMS = "Alba";
export const PB_MENU_POSTS = "\u010cl\u00e1nky";
export const PB_MENU_SHORT_MESSAGES = "Kr\u00e1tk\u00e9 zpr\u00e1vy";
export const PROFILE__POSTS_FOR_REGISTRED_USERS_ARE_NOT_DISPLAYING_TO_YOU = "P\u0159\u00edsp\u011bvky pro registrovan\u00e9 u\u017eivatele se ti nezobrazuj\u00ed.";
export const THIS_PHOTOBLOG_IS_STILL_EMPTY = "Tento profil je zat\u00edm pr\u00e1zdn\u00fd";
